import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-free/js/all.min.js";
import ScrollspyNav from "react-scrollspy-nav";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import "../styles/styles.css";
import "../styles/customstyle.css";

const NavbarStandard = ({
  isAuthenticated = true,
  isMain = false,
  isBlog = false,
}) => {
  const [isMobile, setMobile] = useState(window.innerWidth < 768);

  const updateMobileSizeStatus = () => {
    setMobile(window.innerWidth < 768);
  };

  const navigate = useNavigate();
  const handleSectionNav = (id) => {
    navigate("/");
    setTimeout(() => {
      document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    }, 0);
  };

  useEffect(() => {
    if (isMain) {
      // Navbar shrink function
      const navbarShrink = () => {
        const navbarCollapsible = document.getElementById("mainNav");
        if (!navbarCollapsible) return;
        if (window.scrollY === 0) {
          navbarCollapsible.classList.remove("navbar-shrink");
        } else {
          navbarCollapsible.classList.add("navbar-shrink");
        }
      };

      // Shrink the navbar
      navbarShrink();
      window.addEventListener("scroll", navbarShrink);

      // Activate Bootstrap scrollspy
      const mainNav = document.querySelector("#mainNav");
      if (mainNav) {
        new ScrollspyNav(document.body, {
          target: "#mainNav",
          rootMargin: "0px 0px -40%",
        });
      }

      // Scroll to hide/show navbar and handle active nav links
      let lastScrollTop = 0;
      const headerHeight = document.querySelector("header").offsetHeight;

      const handleScroll = () => {
        const st = window.scrollY;
        if (st > lastScrollTop && st > headerHeight) {
          document.getElementById("mainNav").classList.add("hidden");
        } else {
          document.getElementById("mainNav").classList.remove("hidden");
        }
        lastScrollTop = st;

        const scrollPos =
          document.documentElement.scrollTop || document.body.scrollTop;
        let isActiveSet = false;

        document
          .querySelectorAll(".navbar-nav .nav-link")
          .forEach((currLink) => {
            if (currLink.getAttribute("href") === "/artikel") {
              return;
            }

            const refElement = document.querySelector(
              currLink.getAttribute("href")
            );
            if (
              refElement &&
              refElement.offsetTop <= scrollPos &&
              refElement.offsetTop + refElement.offsetHeight > scrollPos
            ) {
              document
                .querySelectorAll(".navbar-nav .nav-link")
                .forEach((navLink) => navLink.classList.remove("active"));
              currLink.classList.add("active");
              isActiveSet = true;
            }
          });

        if (!isActiveSet) {
          document
            .querySelectorAll(".navbar-nav .nav-link")
            .forEach((navLink) => navLink.classList.remove("active"));
        }
      };

      // Event listeners
      window.addEventListener("resize", updateMobileSizeStatus);
      window.addEventListener("scroll", navbarShrink);
      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("resize", updateMobileSizeStatus);
        window.removeEventListener("scroll", navbarShrink);
        window.removeEventListener("scroll", handleScroll);
      };
    } else {
      // Hide or show navbar based on scroll position
      let lastScrollTop = 0;
      const limitHeight = 100;

      const handleMainNavScroll = () => {
        const st = window.scrollY;

        if (st > lastScrollTop && st > limitHeight) {
          document.getElementById("mainNav").classList.add("hidden");
        } else {
          document.getElementById("mainNav").classList.remove("hidden");
        }

        lastScrollTop = st;
      };

      window.addEventListener("scroll", handleMainNavScroll);
      window.addEventListener("resize", updateMobileSizeStatus);
      return () => {
        window.removeEventListener("resize", updateMobileSizeStatus);
        window.removeEventListener("scroll", handleMainNavScroll);
      };
    }
  }, []);

  return (
    <div>
      {/* Navigation */}
      <Navbar
        expand="lg"
        fixed="top"
        bg="light"
        variant="light"
        id="mainNav"
        className={`py-2 align-center ${
          isAuthenticated ? "" : "blurred-rep no-select"
        }`}
      >
        <Container className="px-3 justify-content-between">
          <Navbar.Brand href="/">
            <img
              src="/img/Logo Ojire.png"
              alt="Ojire Logo"
              style={{ margin: "8px" }}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarTogglerDemo02">
            <a
              className="nav-toggle"
              onClick={() => document.querySelector(".navbar-toggler").click()}
            >
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </a>
          </Navbar.Toggle>
          <Navbar.Collapse id="navbarTogglerDemo02">
            <Nav
              className={`navbar-nav my-2 my-lg-0 ${
                isMobile ? "mx-4" : "mx-auto"
              }`}
            >
              {isMain ? (
                <>
                  <Nav.Link href="#whyOjire" className="nav-link">
                    Kenapa Ojire
                  </Nav.Link>
                  <Nav.Link href="#fiturOjire" className="nav-link">
                    Fitur
                  </Nav.Link>
                  <Nav.Link href="#how" className="nav-link">
                    Cara Kerja
                  </Nav.Link>
                  <Nav.Link href="#faq" className="nav-link">
                    FAQ
                  </Nav.Link>
                  <Nav.Link href="/artikel" className="nav-link">
                    <span className="nav-link-last">Artikel</span>
                  </Nav.Link>
                </>
              ) : (
                <>
                  <div
                    className="nav-link nav-layanan-pointer"
                    onClick={() => handleSectionNav("whyOjire")}
                  >
                    Kenapa Ojire
                  </div>
                  <div
                    className="nav-link nav-layanan-pointer"
                    onClick={() => handleSectionNav("fiturOjire")}
                  >
                    Fitur
                  </div>
                  <div
                    className="nav-link nav-layanan-pointer"
                    onClick={() => handleSectionNav("how")}
                  >
                    Cara Kerja
                  </div>
                  <div
                    className="nav-link nav-layanan-pointer"
                    onClick={() => handleSectionNav("faq")}
                  >
                    FAQ
                  </div>
                  <Nav.Link
                    href="/artikel"
                    className={`nav-link ${isBlog ? "active" : ""}`}
                  >
                    <span className="nav-link-last">Artikel</span>
                  </Nav.Link>
                </>
              )}
            </Nav>
            <div className="d-flex">
              <a href="/demo">
                <Button variant="primary">Daftar Sekarang &gt;</Button>
              </a>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavbarStandard;
